// const userMange = {
//   path: '/sysMange/userMange',
//   component: resolve => require(['@/views/sysMange/userMange'], resolve),
//   name: 'userMange',
//   meta: {title: '用户管理'}
// };
const AuthMange = {
  path: '/sysMange/AuthMange',
  component: resolve => require(['@/views/sysMange/AuthMange'], resolve),
  name: 'AuthMange',
  meta: {title: '权限管理'}
};
const AuthMmemberDetail = {
  path: '/sysMange/AuthMmemberDetail',
  component: resolve => require(['@/views/sysMange/AuthMmemberDetail'], resolve),
  name: 'AuthMmemberDetail',
  meta: {title: '成员授权'},
  hidden: true
};
const AuthMVisitDetail = {
  path: '/sysMange/AuthMVisitDetail',
  component: resolve => require(['@/views/sysMange/AuthMVisitDetail'], resolve),
  name: 'AuthMVisitDetail',
  meta: {title: '访问授权'},
  hidden: true
};
const AccountList = {
  path: '/sysMange/AccountList',
  component: resolve => require(['@/views/sysMange/AccountList'], resolve),
  name: 'AccountList',
  meta: {title: '账号列表'}
};
const AgentList = {
  path: '/sysMange/AgentList',
  component: resolve => require(['@/views/sysMange/agentList'], resolve),
  name: 'AgentList',
  meta: {title: '合作商列表'}
};
const dictType = {
  path: '/sysMange/dictType',
  component: resolve => require(['@/views/sysMange/dictType'], resolve),
  name: 'dictType',
  meta: {title: '数据字典'}
};
const dictTypeDetail = {
  path: '/sysMange/dictTypeDetail',
  component: resolve => require(['@/views/sysMange/dictTypeDetail'], resolve),
  name: 'dictTypeDetail',
  meta: {title: '数据字典详情'},
  hidden: true
};
const config = {
  path: '/sysMange/config',
  component: resolve => require(['@/views/sysMange/config'], resolve),
  name: 'config',
  meta: {title: '系统配置'}
};
const wechatMenu = {
  path: '/sysMange/wechatMenu',
  component: resolve => require(['@/views/sysMange/wechatMenu'], resolve),
  name: 'wechatMenu',
  meta: {title: '公众号菜单'}
};
const version = {
  path: '/sysMange/version',
  component: resolve => require(['@/views/sysMange/version'], resolve),
  name: 'version',
  meta: {title: '版本管理'}
};

export default [AuthMange, AuthMmemberDetail,  AuthMVisitDetail,  AccountList, AgentList, dictType, dictTypeDetail,config, wechatMenu,version];

// 管理列表



// WEBPACK FOOTER //
// ./src/router/modules/sysMange.js